const { postData } = require("./helpers/postData");
const { removeErrors } = require("./helpers/removeErrors");
const { setErrors } = require("./helpers/setErrors");

const loginForm = document.querySelector('[data-form="login"]');

if(loginForm) {
  const action = loginForm.dataset.action;

  loginForm.addEventListener('submit', (e) => {
    e.preventDefault();
    removeErrors();

    const data = {
      phone: e.target.phone.value.trim(),
      password: e.target.password.value.trim(),
    };

    postData(action, data)
      .then(res => {
        if(res.status) {
          window.location.href = res.redirect_url;
        } else {
            const errors = res.errors;
            for (const error in errors) {
                const errorMessage = document.querySelector(`[data-key="${error}"]`);
                errorMessage.innerHTML = '';
                errorMessage.innerHTML = `${errors[error]}`;
            }
        }
      })
      .catch(error => console.log(error));
  });
}
